import { render, staticRenderFns } from "./position-watcher.vue?vue&type=template&id=33b6b5b0&scoped=true&"
import script from "./position-watcher.vue?vue&type=script&lang=js&"
export * from "./position-watcher.vue?vue&type=script&lang=js&"
import style0 from "./position-watcher.vue?vue&type=style&index=0&id=33b6b5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6b5b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b6b5b0')) {
      api.createRecord('33b6b5b0', component.options)
    } else {
      api.reload('33b6b5b0', component.options)
    }
    module.hot.accept("./position-watcher.vue?vue&type=template&id=33b6b5b0&scoped=true&", function () {
      api.rerender('33b6b5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/position-watcher.vue"
export default component.exports